var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import { subscribe, unsubscribe, publish } from '@wh/message-bus';
import MESSAGE_BUS_TOPICS from '@wh/message-bus-topics';
import { getDeviceInfo } from '../../../utils/deviceInfo';
import config from '../../../config';
import { publishOnLoginOpen, publishOpenByoMenuAnalytics, } from '../../analyticsHelpers';
import { GET_FEATURE_FLAG, OPEN_BUILD_YOUR_ODDS_EVENT, CLOSE_BUILD_YOUR_ODDS_MODAL, OPEN_BUILD_YOUR_ODDS_MODAL, GET_ODDS_FORMAT, START_NEW_LOGIN_PROCESS, BYO_CAMPAIGN_QUERY_PARAM, EDIT_BUILD_YOUR_ODDS_SELECTION, NATIVE_CLOSE_DRAWER, MONITORING_OPEN_MODAL, UI_READY, } from '../../../constants';
import { App } from '../ui';
import * as actions from '../../../redux/actions';
import { addPageAction } from '../../../utils/addPageAction';
const shouldUseBYOFreedom = () => {
    const { useBYOFreedom, byoFreedomEnabled, byoMarketsEnabled } = config;
    if (byoFreedomEnabled && !byoMarketsEnabled) {
        return true;
    }
    if (!byoFreedomEnabled && byoMarketsEnabled) {
        return false;
    }
    return useBYOFreedom;
};
const cleanPreviousEventSelections = (eventId, currentEventId, clearSlip, setEventId, id, editId) => {
    if (!eventId || eventId !== currentEventId) {
        clearSlip();
        setEventId(currentEventId);
    }
    else if (id && editId && id !== editId) {
        clearSlip();
    }
};
const retry = (callback, times = 3) => {
    let numberOfTries = 0;
    return new Promise((resolve) => {
        const interval = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
            numberOfTries += 1;
            if (numberOfTries === times) {
                clearInterval(interval);
            }
            try {
                yield callback();
                clearInterval(interval);
                resolve();
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.log('error', error);
            }
        }), 500);
    });
};
const pageActionOpenModal = () => addPageAction(MONITORING_OPEN_MODAL, {});
export class AppComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.subscriptionToken = [];
        this.isBYOButtonHidden = () => {
            const container = document.querySelector('.byo-button-container');
            return container && container.classList.contains('displayNone');
        };
        this.showBYOButton = () => {
            const container = document.querySelector('.byo-button-container');
            if (container && container.classList.contains('displayNone')) {
                container.classList.remove('displayNone');
            }
        };
        this.openCurrentEvent = () => {
            const { getMarkets, clearSlip, setEventId, eventId, clearImpactSubData } = this.props;
            const { locale, eventId: currentEventId } = config;
            const deviceInfo = getDeviceInfo();
            if (deviceInfo && deviceInfo.isNative) {
                publish(NATIVE_CLOSE_DRAWER);
            }
            cleanPreviousEventSelections(eventId, currentEventId, clearSlip, setEventId);
            clearImpactSubData();
            if (currentEventId) {
                getMarkets(locale, currentEventId, shouldUseBYOFreedom());
                this.open();
            }
        };
        this.openLoginModal = () => {
            const { setWaitingForLogin } = this.props;
            const deviceInfo = getDeviceInfo();
            // Update state
            setWaitingForLogin(true);
            if (deviceInfo && deviceInfo.isNative && window) {
                window.location.href = 'nw-showlogin://';
            }
            else {
                // open old loggin
                const login = document.querySelector('#account-section section.account');
                if (login) {
                    login.classList.add('-expanded');
                }
                // open new loggin
                publish(START_NEW_LOGIN_PROCESS, {});
            }
            publishOnLoginOpen();
        };
        this.pushHistoryState = () => {
            const { history, location } = this.props;
            const pathname = window ? window.location.pathname : location.pathname;
            history.push({
                pathname,
                state: config.locationState,
            });
        };
        this.openEvent = (topic, payload) => {
            const { getMarkets, isModalOpen, clearSlip, setEventId, eventId, clearImpactSubData } = this.props;
            const { locale, useBYOFreedom, eventId: currentEventId } = config;
            cleanPreviousEventSelections(eventId, (payload === null || payload === void 0 ? void 0 : payload.eventId) || currentEventId, clearSlip, setEventId);
            clearImpactSubData();
            if (!isModalOpen || currentEventId) {
                getMarkets(locale, (payload === null || payload === void 0 ? void 0 : payload.eventId) || currentEventId, useBYOFreedom);
                this.open();
            }
        };
        this.editSelection = (topic, payload) => {
            const { editSelections, isModalOpen, clearSlip, setEventId, eventId, editId } = this.props;
            cleanPreviousEventSelections(eventId, payload.eventId, clearSlip, setEventId, payload === null || payload === void 0 ? void 0 : payload.id, editId);
            editSelections(payload);
            if (!isModalOpen) {
                this.open();
            }
        };
        this.open = () => {
            const { isUserLoggedIn, openModal } = this.props;
            if (isUserLoggedIn) {
                publishOpenByoMenuAnalytics();
                pageActionOpenModal();
                this.pushHistoryState();
                openModal();
            }
            else {
                this.openLoginModal();
            }
        };
        this.close = () => {
            const { closeModal, history } = this.props;
            // Unset BYO location
            history.goBack();
            closeModal();
        };
        this.setOddsFormat = (topic, payload) => {
            const { addOddsFormatToStore } = this.props;
            addOddsFormatToStore(payload);
        };
        this.setLoggedInState = (topic, { isLoggedIn }) => {
            const { setUserLoggedInState, isModalOpen, isWaitingForLogin, setWaitingForLogin, isOpeningFromCampaign, setIsOpeningFromCampaign, } = this.props;
            setUserLoggedInState(isLoggedIn);
            // Persist opening on campaign trigger
            if (isOpeningFromCampaign) {
                setIsOpeningFromCampaign(false);
                return;
            }
            if (isWaitingForLogin && isLoggedIn) {
                this.open();
            }
            else if (isModalOpen) {
                this.close();
            }
            setWaitingForLogin(false);
        };
        this.subscriptionToken = [
            subscribe(OPEN_BUILD_YOUR_ODDS_EVENT, this.openEvent),
            subscribe(OPEN_BUILD_YOUR_ODDS_MODAL, this.openCurrentEvent),
            subscribe(EDIT_BUILD_YOUR_ODDS_SELECTION, this.editSelection),
            subscribe(CLOSE_BUILD_YOUR_ODDS_MODAL, this.close),
            subscribe(GET_ODDS_FORMAT, this.setOddsFormat),
            subscribe(MESSAGE_BUS_TOPICS.COMMON.LOGIN_STATE, this.setLoggedInState),
        ];
        this.checkByoInUrl();
    }
    /* eslint-disable camelcase */
    UNSAFE_componentWillMount() {
        if (this.isBYOButtonHidden()) {
            retry(() => __awaiter(this, void 0, void 0, function* () {
                publish(GET_FEATURE_FLAG, {
                    featureKey: 'buildYourOddsInPlayEnabled',
                    callback: (featureFlag, featureKey) => {
                        if (featureFlag.isEnabled) {
                            this.showBYOButton();
                        }
                    }
                });
            }));
        }
        publish(UI_READY);
    }
    componentWillUnmount() {
        this.subscriptionToken.forEach((token) => unsubscribe(token));
    }
    // To navigate to an event and open byo directly, used in emails campaigns and banners
    checkByoInUrl() {
        const { history, location, setIsOpeningFromCampaign } = this.props;
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.has(BYO_CAMPAIGN_QUERY_PARAM)) {
            queryParams.delete(BYO_CAMPAIGN_QUERY_PARAM);
            history.replace({
                search: queryParams.toString(),
            });
            setIsOpeningFromCampaign(true);
            this.openCurrentEvent();
        }
    }
    render() {
        const { isModalOpen, slipExpanded, expandSlip, addingToBetslip, location, impactSub } = this.props;
        const { locale, showImpactSub } = config;
        const showImpactSubOffer = showImpactSub && (locale === 'en-gb' || locale === 'es-es') && (impactSub === null || impactSub === void 0 ? void 0 : impactSub.eligible);
        if (!isModalOpen) {
            return null;
        }
        if (location.state === config.locationState) {
            return (React.createElement(Suspense, { fallback: "" },
                React.createElement(App, { slipExpanded: slipExpanded, expandSlip: expandSlip, addingToBetslip: addingToBetslip, byoInPlay: config.byoInPlay, showImpactSubOffer: showImpactSubOffer })));
        }
        return null;
    }
}
const mapStateToProps = ({ slip, app, auth, markets }) => (Object.assign(Object.assign(Object.assign(Object.assign({}, slip), app), auth), markets));
const mapDispatchToProps = {
    getMarkets: actions.getMarkets,
    editSelections: actions.editSelections,
    addOddsFormatToStore: actions.addOddsFormatToStore,
    expandSlip: actions.expandSlip,
    openModal: actions.openModal,
    closeModal: actions.closeModal,
    clearSlip: actions.clearSlip,
    setUserLoggedInState: actions.setUserLoggedInState,
    setWaitingForLogin: actions.setWaitingForLogin,
    setIsOpeningFromCampaign: actions.setIsOpeningFromCampaign,
    setEventId: actions.setEventId,
    clearImpactSubData: actions.clearImpactSubData
};
export const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(AppComponent);
